
import CreateAccountLink from '~/components/molecules/auth/CreateAccountLink'
import JoinWithCodeLink from '~/components/molecules/auth/JoinWithCodeLink'
import LoginForm from '~/components/organisms/auth/LoginForm'
import LoginWithApple from '~/components/molecules/auth/LoginWithApple'
import FacebookLoginButton from '~/components/organisms/auth/FacebookLoginButton'
import LoginError from '~/components/molecules/auth/LoginError.vue'

export default {
  components: {
    CreateAccountLink,
    FacebookLoginButton,
    JoinWithCodeLink,
    LoginError,
    LoginForm,
    LoginWithApple,
  },

  props: {
    callbackRoute: {
      type: [Object, String],
      default: undefined,
    },
    callbackNewWindow: {
      type: Boolean,
      default: false,
    },
    signupRoute: {
      type: [Object, String],
      default: undefined,
    },
  },
}
